module.exports = __webpack_public_path__ + "media/images/features/modification/heading-question-f45baf3bbc07e3561472351c608ca809.svg";